<template>
    <div class="d-flex justify-content-start">
        <a v-if="$can('change-setting', 'accounting')" @click.prevent="deleteHoliday" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-trash"></i>
        </a>
        <a v-if="$can('change-setting', 'accounting')" @click.prevent="editHoliday" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
            <i class="fa fa-edit"></i>
        </a>
    </div>
</template>

<script>
import $ from 'jquery';
import Vue from 'vue';
import toastr from 'toastr';
import { accountingService } from "@/common/api.service";
import { EventBus } from "../index";
import { starShopAccountingService } from '../../../common/api.service';

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        activeService() {
            return this.$route.path.includes('pf') ? accountingService : starShopAccountingService;
        },
        selector() {
            return $('tr[data-row="'+this.index+'"');
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-top-left",
                preventDuplicates: false,
                rtl: false
            };

            return toastr;
        }
    },
    methods: {
         deleteHoliday(e) {
            console.log(this.$route.path.includes('pf'));
            console.log(this.$route.path.includes('starshop'));
            this.activeService.deleteHoliday(this.row.id).then(
                response => {
                    this.toastr.success(response.data.message);
                    this.datatable.reload();
                },
                error => {
                    this.toastr.error(error.response.data.message || "An error occurred while deleting the account.");
                }
            );
        },
        editHoliday(e) {            
            EventBus.$emit('edit-holiday', this.row);            
        },
    },
});
</script>